var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31,
    height: 16,
    viewBox: "0 0 31 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_289136588074958136562685565484070266240",
    x1: "50%",
    x2: "50%",
    y1: "32.846%",
    y2: "90.794%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_323230529282824730900425268573106325591",
    x1: "50%",
    x2: "50%",
    y1: "32.846%",
    y2: "90.794%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "hinava_random_uuid_67143463054754380684676015655041046668",
    d: "M11.94 12v-1.296H8.31V8.609h3.094V7.347H8.31v-1.86h3.62V4.18H6.698V12h5.242zm3.29.105c.444 0 .849-.09 1.215-.27.367-.18.656-.434.868-.76.212-.327.32-.688.323-1.084h-1.459c-.006.262-.098.471-.277.63-.179.157-.411.236-.698.236-.373 0-.65-.13-.832-.392-.182-.262-.273-.692-.273-1.292v-.157c0-.593.092-1.021.275-1.284.183-.264.457-.395.82-.395.294 0 .53.094.708.282.179.188.271.432.277.732h1.46c-.007-.686-.23-1.236-.67-1.65-.44-.415-1.024-.622-1.75-.622-.83 0-1.483.267-1.96.801-.476.534-.714 1.25-.714 2.145v.1c0 .932.24 1.661.72 2.189.48.527 1.135.791 1.967.791zm5.802 0c.838 0 1.506-.27 2.004-.808.497-.539.746-1.253.746-2.143l-.01-.397c-.057-.825-.334-1.478-.83-1.958-.495-.48-1.135-.72-1.92-.72-.551 0-1.036.124-1.454.37-.417.248-.737.597-.959 1.048-.221.451-.332.965-.332 1.543v.071c0 .925.25 1.655.748 2.19.5.536 1.168.804 2.007.804zm0-1.248c-.386 0-.683-.146-.89-.438-.207-.291-.31-.713-.31-1.265 0-.621.103-1.08.31-1.375.207-.295.5-.442.88-.442.383 0 .68.149.892.447.212.298.318.717.318 1.256 0 .634-.106 1.096-.318 1.384-.212.289-.506.433-.882.433z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#454545",
    xlinkHref: "#hinava_random_uuid_67143463054754380684676015655041046668"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#hinava_random_uuid_289136588074958136562685565484070266240)",
    xlinkHref: "#hinava_random_uuid_67143463054754380684676015655041046668"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hinava_random_uuid_323230529282824730900425268573106325591)",
    d: "M28.5 0C29.88 0 31 1.12 31 2.5v11c0 1.38-1.12 2.5-2.5 2.5h-26C1.12 16 0 14.88 0 13.5v-11C0 1.12 1.12 0 2.5 0h26zm0 1h-26c-.78 0-1.42.595-1.493 1.356L1 2.5v11c0 .78.595 1.42 1.356 1.493L2.5 15h26c.78 0 1.42-.595 1.493-1.356L30 13.5v-11c0-.78-.595-1.42-1.356-1.493L28.5 1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEco);
export default __webpack_public_path__ + "static/media/eco.1af9739b07c95dc870d0d1f667e287a2.svg";
export { ForwardRef as ReactComponent };